import { useDeleteMetaConversionsMutation } from '../queries/deleteMetaConversionsMutation';
import { useGetMetaConversionQuery } from '../queries/getMetaConversionQuery';
import { useUpdateMetaconversionsMutation } from '../queries/updateMetaConversionMutation';
export const useMetaConversionPixel = () => {
    const { metaConversionQuery, invalidateMetaConversionQuery } = useGetMetaConversionQuery();
    const { metaConversionUpdateMutation } = useUpdateMetaconversionsMutation();
    const { metaConversionDeleteMutation } = useDeleteMetaConversionsMutation();
    return {
        pixelId: metaConversionQuery.data?.pixelId,
        isLoading: metaConversionQuery.isLoading,
        error: metaConversionQuery.error,
        updatePixel: ({ pixelId, accessToken }) => metaConversionUpdateMutation.mutate([pixelId, accessToken], {
            onSuccess: () => {
                invalidateMetaConversionQuery();
            },
        }),
        deletePixel: () => metaConversionDeleteMutation.mutate([], {
            onSuccess: () => {
                invalidateMetaConversionQuery();
            },
        }),
    };
};
